/**
 * Use in case of network response errors (when the response status code is out of 2xx range).
 */
export class NetworkError extends Error {
  public status: number | undefined;

  constructor(message: string, status?: number) {
    super(message);
    this.status = status;
    this.name = "NetworkError";
  }
}

/**
 * Use in case of unexpected errors.
 */
export class UnexpectedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "UnexpectedError";
  }
}
